'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  justify-content: flex-start;\n\n  input:disabled {\n    background: ', ';\n  }\n  [contenteditable]:focus {\n   outline: 0px solid;\n   background: #f7f7f7;.\n  }\n'], ['\n  display: flex;\n  justify-content: flex-start;\n\n  input:disabled {\n    background: ', ';\n  }\n  [contenteditable]:focus {\n   outline: 0px solid;\n   background: #f7f7f7;.\n  }\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  top: 5px;\n  float: left;\n  color: ', ';\n  padding-left: 7px;\n'], ['\n  top: 5px;\n  float: left;\n  color: ', ';\n  padding-left: 7px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _MozartTextBox = require('../../MozartTextBox');

var _MozartTextBox2 = _interopRequireDefault(_MozartTextBox);

var _utils = require('../../utils');

var _color = require('../../color');

var _color2 = _interopRequireDefault(_color);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var Container = _styledComponents2.default.div(_templateObject, _color2.default.grey_accent_2);

var ErrorText = _styledComponents2.default.div(_templateObject2, _color2.default.r34);

var MozartTextBoxInline = function (_Component) {
  _inherits(MozartTextBoxInline, _Component);

  function MozartTextBoxInline(props) {
    _classCallCheck(this, MozartTextBoxInline);

    var _this = _possibleConstructorReturn(this, (MozartTextBoxInline.__proto__ || Object.getPrototypeOf(MozartTextBoxInline)).call(this, props));

    _this.state = {
      init: true,
      editting: false,
      errorText: ''
    };
    return _this;
  }

  _createClass(MozartTextBoxInline, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          id = _props.id,
          onChange = _props.onChange;

      document.getElementById(id).addEventListener("blur", function () {
        if (document.getElementById(id).innerText.trim() === '') {
          document.getElementById(id).focus();
        }
        if (document.getElementById(id).innerText) {
          if (onChange) {
            onChange(document.getElementById(id).innerText);
          }
        }
      });
      // document.getElementById('editor').addEventListener("click", function(){
      //   if (document.getElementById('editor').innerText.trim() === '') {
      //     document.getElementById('editor').focus();
      //   }
      //   callBack(document.getElementById('editor').innerText);
      // });
      // document.getElementById('editor').addEventListener("keydown", function(){
      //   if (document.getElementById('editor').innerText.trim() === '') {
      //     document.getElementById('editor').focus();
      //   }
      //   callBack(document.getElementById('editor').innerText);
      // });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.recievedData === '') {
        this.setState({
          errorText: 'This field is required'
        });
      } else {
        this.setState({
          errorText: ''
        });
      }
    }
  }, {
    key: 'validate',
    value: function validate() {
      if (document.getElementById(nextProps.id).innerText.trim() === '') {
        this.setState({
          errorText: 'This field is required'
        });
        document.getElementById(nextProps.id).focus();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          style = _props2.style,
          hintText = _props2.hintText,
          onChange = _props2.onChange,
          defaultEditValue = _props2.defaultEditValue,
          validationBool = _props2.validationBool,
          id = _props2.id;
      var editting = this.state.editting;

      var textboxStyle = { padding: '10px', borderRadius: '5px', border: '1px solid #2126e0', minWidth: '285px' };

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          Container,
          { style: style, 'data-qa': this.props.testId },
          _react2.default.createElement(
            'element',
            { style: textboxStyle, contentEditable: 'true', id: id },
            defaultEditValue !== undefined ? defaultEditValue : hintText
          )
        ),
        _react2.default.createElement(
          ErrorText,
          { id: 'errorText' },
          validationBool ? this.state.errorText : ''
        )
      );
    }
  }]);

  return MozartTextBoxInline;
}(_react.Component);

MozartTextBoxInline.propTypes = {
  /** qa attribute */
  testId: _propTypes2.default.string,
  /** theme attribute */
  themeId: _propTypes2.default.string,
  /** style override */
  style: _propTypes2.default.object,
  /** default value when user click on edit icon */
  defaultEditValue: _propTypes2.default.string,
  /** place holder */
  hintText: _propTypes2.default.string,
  /** on edit click */
  onEditClick: _propTypes2.default.func,
  /** on change */
  onChange: _propTypes2.default.func.isRequired,
  /** single or multiple line */
  multiLine: _propTypes2.default.bool,
  /** turn on validation */
  validationBool: _propTypes2.default.bool,
  /** updated data */
  recievedData: _propTypes2.default.string,
  /** uniique key attribute */
  id: _propTypes2.default.string
};
MozartTextBoxInline.defaultProps = {
  testId: 'MozartTextBoxInline',
  id: 'mozart_text_box_inline_' + Math.random(),
  ref: 'mozart_text_box_inline_' + Math.random(),
  disabled: false,
  value: '',
  errorText: '',
  limit: 3000,
  minChars: 0,
  rteHeight: '200',
  unControlled: false,
  stripNonNumeric: false,
  validationBool: true,
  style: {},
  recievedData: ''
};
exports.default = MozartTextBoxInline;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@pgforsta/mozart_ui/lib/components/Mozart/MozartTextBox/MozartTextBoxInline/MozartTextBoxInline.js
// module id = 2119
// module chunks = 1